/* eslint-disable react/jsx-no-leaked-render -- It's cleaner to have && in templates */
import type { ReactNode, HTMLAttributes } from 'react';
import cx from 'clsx';
import { useIntl } from 'react-intl';
import type { BaseButtonProps } from '../button';
import { Button } from '../button';
import { LottiePlayer } from '../lottie-player';
import genericError from '../../assets/lotties/generic-error.json';
import styles from './error-state.module.css';

export interface ErrorStateProps extends HTMLAttributes<HTMLDivElement> {
  headingLevel?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  onRetry?: () => void;
  retryButtonText?: string;
  subtitle?: string;
  title: string;
  retryButtonVariant?: BaseButtonProps['variant'];
}

export function ErrorState({
  headingLevel = 'h2',
  retryButtonText,
  onRetry,
  subtitle,
  title,
  retryButtonVariant = 'tertiary',
  ...props
}: ErrorStateProps): ReactNode {
  const intl = useIntl();

  const Heading = headingLevel;

  return (
    <div className={styles.container} data-test-error-state role="alert" {...props}>
      <div className={cx(styles.lottie, 'mb-32')}>
        <LottiePlayer animationData={genericError} data-testid="lottie" />
      </div>

      <Heading className="title-2 mb-8">{title}</Heading>
      {subtitle && <p className={cx('body-2', onRetry && 'mb-32')}>{subtitle}</p>}
      {onRetry && (
        <Button data-test-error-state-retry onPress={onRetry} variant={retryButtonVariant}>
          {retryButtonText ? retryButtonText : intl.formatMessage({ id: 'error-state-btn-retry' })}
        </Button>
      )}
    </div>
  );
}
